import React from "react";
import { sanitiseString, concatStringFromClassesArrayList } from "../../Utils";
import { SkipToContent } from "../SkipToContent";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { Breadcrumb } from "../Breadcrumb";
import { HeroPanel } from "../HeroPanel";

export interface Props {
  children: any;
  dataTestId?: string;
  classes?: string;
  pageConfig: {
    skipToContent: ReturnType<typeof SkipToContent>;
    header: ReturnType<typeof Header>;
    footer: ReturnType<typeof Footer>;
    breadcrumb?: ReturnType<typeof Breadcrumb>;
    heroPanel?: ReturnType<typeof HeroPanel>;
    pageColNumber?: number;
  };
}

export const BaseLayout = (props: Props) => {
  const containerClassList = {
    defaultClass: "ons-page__container ons-container",
    optionalClasses: [props.classes ? props.classes : "ons-container--wide"],
  };
  const containerClassName =
    concatStringFromClassesArrayList(containerClassList);

  const gridClassList = {
    defaultClass: "ons-grid__col",
    optionalClasses: [
      props.pageConfig.pageColNumber &&
      props.pageConfig.pageColNumber >= 1 &&
      props.pageConfig.pageColNumber <= 12
        ? `ons-col-${props.pageConfig.pageColNumber}@m`
        : "ons-col-12@m",
    ],
  };

  const gridClassName = concatStringFromClassesArrayList(gridClassList);

  return (
    <div className="ons-page" data-testid={sanitiseString(props.dataTestId)}>
      <div className="ons-page__content">
        {props.pageConfig.skipToContent}
        {props.pageConfig.header}
        {props.pageConfig.heroPanel}
        <div className={containerClassName}>
          {props.pageConfig.breadcrumb}
          <div className="ons-grid">
            <div className={gridClassName}>
              <main id="main-content" className="ons-page__main">
                {props.children}
              </main>
            </div>
          </div>
        </div>
        {props.pageConfig.footer}
      </div>
    </div>
  );
};
